<div class="ap-card"
     [class.ap-card-committed]="finalState?.kind === 'committed'"
     [class.ap-card-cancelled]="finalState?.kind === 'cancelled'">

    <!-- =====================================================================
         CANCELLED (rejected)
         Figma 1575-25025. Compact: just the action title + a red "Rejected"
         badge, then a single footer row "Rejected — no changes committed".
         No "Try again" affordance (designer-confirmed cut).
         ===================================================================== -->
    <ng-container *ngIf="finalState?.kind === 'cancelled'">
        <div class="ap-card-header">
            <div class="ap-card-header-text">
                <h4 class="ap-card-title">{{ headerTitle }}</h4>
            </div>
            <span class="ap-card-state-badge tone-rejected">Rejected</span>
        </div>
        <div class="ap-card-footer ap-card-footer-rejected">
            <span class="ap-card-footer-label">Rejected — no changes committed</span>
        </div>
    </ng-container>

    <!-- =====================================================================
         COMMITTED (approved)
         Collapsed to the footer only after the action commits — the preview
         body (template / recipients / impact summary) hides so the user
         can't re-confirm or re-edit a write that already happened. Just a
         green success line + "View created" deeplink remain.
         ===================================================================== -->
    <ng-container *ngIf="finalState?.kind === 'committed'">
        <div class="ap-card-footer ap-card-footer-approved">
            <i class="ph-bold ph-check icon-success icon-16" aria-hidden="true"></i>
            <span class="ap-card-footer-label">{{ completedLabel }}</span>
            <flex-spacer></flex-spacer>
            <a
                *ngIf="destinationRoute"
                class="ap-card-view-created"
                [routerLink]="destinationRoute">
                {{ destinationLabel }}
                <i class="ph-bold ph-arrow-up-right icon-text icon-14" aria-hidden="true"></i>
            </a>
        </div>
    </ng-container>

    <!-- =====================================================================
         PENDING (interactive)
         ===================================================================== -->
    <ng-container *ngIf="finalState === null">
        <ng-container *ngFor="let section of sections; let i = index; trackBy: trackBySectionIndex">
            <div class="ap-section" [attr.data-kind]="section.kind">
                <ng-container [ngSwitch]="section.kind">
                    <app-ap-header-section
                        *ngSwitchCase="'header'"
                        [section]="$any(section)">
                    </app-ap-header-section>

                    <app-ap-status-picker-section
                        *ngSwitchCase="'status_picker'"
                        [section]="$any(section)"
                        [pendingEdit]="pendingEdits.status_picker ?? null"
                        (edit)="onStatusEdit($event)">
                    </app-ap-status-picker-section>

                    <app-ap-email-template-section
                        *ngSwitchCase="'email_template'"
                        [section]="$any(section)"
                        [pendingEdit]="pendingEdits.email_template ?? null"
                        (edit)="onEmailEdit($event)">
                    </app-ap-email-template-section>

                    <app-ap-toggle-section
                        *ngSwitchCase="'toggle'"
                        [section]="$any(section)"
                        [pendingValue]="toggleValue($any(section).key)"
                        [disabled]="finalState !== null || submitting"
                        (edit)="onToggleEdit($event)">
                    </app-ap-toggle-section>

                    <app-ap-recipients-section
                        *ngSwitchCase="'recipients'"
                        [section]="$any(section)"
                        [pendingEdit]="pendingEdits.recipients ?? null"
                        (edit)="onRecipientsEdit($event)"
                        (listAction)="onRecipientsListAction($event)">
                    </app-ap-recipients-section>

                    <app-ap-impact-summary-section
                        *ngSwitchCase="'impact_summary'"
                        [section]="$any(section)"
                        [primaryOverride]="impactSummaryPrimaryOverride">
                    </app-ap-impact-summary-section>

                    <app-ap-key-value-section
                        *ngSwitchCase="'key_value'"
                        [section]="$any(section)">
                    </app-ap-key-value-section>

                    <app-ap-info-block-section
                        *ngSwitchCase="'info_block'"
                        [section]="$any(section)">
                    </app-ap-info-block-section>

                    <div *ngSwitchDefault class="ap-section-placeholder">
                        <span class="ap-section-placeholder-kind">{{ section.kind }}</span>
                        <span *ngIf="!isKnownKind(section)" class="ap-section-placeholder-note">
                            Unknown section kind — UI not yet built. Backend may have shipped a
                            newer section type than this client knows about.
                        </span>
                    </div>
                </ng-container>
            </div>
            <hr class="ap-section-divider" *ngIf="i < sections.length - 1" />
        </ng-container>

        <div class="ap-card-actions"
             *ngIf="payload?.preview?.actions as actions">
            <flex-spacer></flex-spacer>
            <button
                type="button"
                mat-flat-button
                [disableRipple]="true"
                color="accent"
                class="ap-destructive-button"
                [disabled]="submitting"
                (click)="onCancel()">
                {{ actions.destructive.label }}
            </button>
            <button
                type="button"
                mat-flat-button
                [disableRipple]="true"
                color="primary"
                class="ap-primary-button"
                [disabled]="submitting || isPrimaryDisabled"
                [title]="isPrimaryDisabled ? 'Pick at least one unit first' : null"
                (click)="onConfirm()">
                <mat-spinner *ngIf="submitting; else primaryIcon" diameter="16"></mat-spinner>
                <ng-template #primaryIcon>
                    <i *ngIf="actions.primary.icon === 'check'"
                       class="ph-bold ph-check icon-white icon-16"
                       aria-hidden="true"></i>
                </ng-template>
                {{ submitting ? 'Creating…' : primaryButtonLabel }}
            </button>
        </div>
    </ng-container>
</div>
